export const transaksiKeluarFormData = () => {
    return [
        {
            id : "jumlah_transaksi_keluar",
            label : "Jumlah Transaksi Keluar",
            fields: [{
                type: "input",
                placeholder: "Masukan Nilai Transaksi..."
            }]
        }
    ]
}